import { useFishDetails } from '../FishDetailsContext';
import ManualCharge from '@Components/ManualCharge';

export default function ManualChargeDialogBody() {
  const {
    actor,
  } = useFishDetails();

  return (
    <>
                <h1 className="font-questrial px-4 pt-10 text-2xl font-bold">
                  Manual Charge
                </h1>
                <div className="pt-4">
                  <ManualCharge fish={actor} />
                </div>
    </>
  );
}
